import { centralUser, cmsSession } from './centralAuth';
import Cookies from 'universal-cookie';
import { appEnv } from '../config/env';

// Local-ID/role adapter only. Accounts owns the credentials and OIDC tokens.
export class TokenService {
  public getTokenNoRedirect = () => {
    const user = centralUser(); const session = cmsSession();
    if (!user || !session) return null;
    const selected = localStorage.getItem(appEnv.storageCurrentSiteKey);
    const site = session.context.workspaces.find(x => x.businessId === selected) ?? session.context.workspaces[0];
    return {
      access_token: `Bearer ${user.access_token}`, expires_in: user.expires_in ?? 0,
      expires_at: new Date((user.expires_at ?? 0) * 1000).toISOString(),
      user_id: site?.localUserId ?? '', email: session.context.email,
      user_type: session.isSystemAdmin ? 5 : site?.role ?? 0,
    };
  };
  public getToken = () => {
    const token = this.getTokenNoRedirect();
    if (!token || this.hasTokenExpired()) { window.dispatchEvent(new Event('cms-session-ended')); return null; }
    return token;
  };
  public clearToken = (): void => {
    for (const store of [localStorage, sessionStorage]) {
      store.removeItem(appEnv.storageTokenKey);
      store.removeItem(`${appEnv.storageTokenKey}_RememberMe`);
    }
    new Cookies().remove(appEnv.storageTokenKey);
  };
  public hasTokenExpired = (): boolean => {
    const user = centralUser();
    if (!user || !cmsSession()) return true;
    // Network calls renew the central access token before use.
    return !user.refresh_token && (user.expires_at ?? 0) * 1000 <= Date.now();
  };
  public isSystemAdmin = (): boolean => cmsSession()?.isSystemAdmin ?? false;
  public getUserId = (): string | null => this.getToken()?.user_id || null;
}
